import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationDE from './../assets/i18n/de.json';
import translationEN from './../assets/i18n/en.json';

const resources = {
	en: {
		translation: translationEN,
	},
	de: {
		translation: translationDE,
	},
};

function detectBrowserLanguage() {
	const lang = navigator.language || navigator.userLanguage;
	return lang.split('-')[0] ?? '';
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources: resources,
		lng: detectBrowserLanguage(),
		fallbackLng: 'en',

		interpolation: {
			escapeValue: false, // react already safes from xss
		},
	});

export default i18n;
